// Mock data for European Touch Painting website

export const services = [
  {
    id: 1,
    title: "Interior Painting",
    description: "Transform your living spaces with precision interior painting. From single rooms to entire homes, we deliver flawless finishes that elevate your interiors.",
    features: ["Premium paints", "Color consultation", "Furniture protection", "Clean job sites"],
    icon: "Home",
    image: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/f0cb1efi_interior.jpeg"
  },
  {
    id: 2,
    title: "Exterior Painting",
    description: "Protect and beautify your property's exterior with weather-resistant, long-lasting finishes that enhance curb appeal and property value.",
    features: ["Weather-resistant coatings", "Surface preparation", "Pressure washing", "Multi-story expertise"],
    icon: "Building",
    image: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/c77g5hnc_pexels-jan-van-der-wolf-11680885-6569991.jpg"
  },
  {
    id: 3,
    title: "Custom Finishes",
    description: "Specialty finishes including faux finishes, textures, accent walls, and decorative painting that add unique character to your spaces.",
    features: ["Venetian plaster", "Accent walls", "Textured finishes", "Metallic effects"],
    icon: "Sparkles",
    image: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/m1o414fg_custom.jpeg"
  },
  {
    id: 4,
    title: "Commercial Painting",
    description: "Professional commercial painting services for offices, retail spaces, and buildings. Minimal disruption, maximum quality.",
    features: ["Flexible scheduling", "Large-scale projects", "Fast turnaround", "Licensed & insured"],
    icon: "Building2",
    image: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/tts4xu78_pexels-iamluisao-12706241.jpg"
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Luxury Home Interior",
    category: "Luxury Projects",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/9yj6u4ws_asdfsdf.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/9yj6u4ws_asdfsdf.jpg",
    description: "High-ceiling foyer with elegant architectural details and custom finish work"
  },
  {
    id: 2,
    title: "Custom Residential Exterior",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/pvwwlna1_cdls%2Cc.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/pvwwlna1_cdls%2Cc.jpg",
    description: "Complete exterior painting transformation for modern stone home"
  },
  {
    id: 3,
    title: "Storefront Transformation",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/za2z9iko_cdmskmds.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/za2z9iko_cdmskmds.jpg",
    description: "Dramatic exterior painting project with modern color transformation"
  },
  {
    id: 4,
    title: "High-End Kitchen Refinishing",
    category: "Luxury Projects",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/66fnbejw_cdshu.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/66fnbejw_cdshu.jpg",
    description: "Coffered ceiling and custom cabinet painting in luxury kitchen"
  },
  {
    id: 5,
    title: "Elegant Interior Room",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/3yw77vki_cdskcmd.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/3yw77vki_cdskcmd.jpg",
    description: "Sophisticated gray tones with custom trim and coffered ceiling details"
  },
  {
    id: 6,
    title: "Modern Condo Suite",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/tjswa9jp_usethisnoe.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/tjswa9jp_usethisnoe.jpg",
    description: "Contemporary suite with custom wall finishes and modern aesthetic"
  },
  {
    id: 7,
    title: "Luxury Condo Bathroom",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/su1sqloa_usethisone.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/su1sqloa_usethisone.jpg",
    description: "Modern bathroom with custom tile work and elegant finish"
  },
  {
    id: 8,
    title: "Custom Wood Closet Doors",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/use6s75x_usethisonefejdi.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/use6s75x_usethisonefejdi.jpg",
    description: "Beautiful natural wood finish on custom closet doors"
  },
  {
    id: 9,
    title: "Contemporary Condo Bedroom",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/v8d08nce_usethosne.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/v8d08nce_usethosne.jpg",
    description: "Modern bedroom with LED lighting and premium paint finishes"
  },
  {
    id: 10,
    title: "Multi-Story Building Exterior",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/4599pjph_vfkdmcv.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/4599pjph_vfkdmcv.jpg",
    description: "Complete building exterior transformation with modern finishes"
  },
  {
    id: 11,
    title: "Front Door Restoration",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/y3415qwc_Painting.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/y3415qwc_Painting.jpg",
    description: "Beautiful wood door refinishing with rich stain and protective finish"
  },
  {
    id: 12,
    title: "Multi-Unit Residential Complex",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/n7181722_rapign.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/n7181722_rapign.jpg",
    description: "Large-scale exterior transformation from green to modern blue palette"
  },
  {
    id: 13,
    title: "Luxury Master Bathroom",
    category: "Luxury Projects",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/bfqqwosf_use.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/bfqqwosf_use.jpg",
    description: "Stunning bathroom with geometric gold accent wall and crystal chandelier"
  },
  {
    id: 14,
    title: "Waterfront Multi-Unit Property",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/hj9llize_useiujf.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/hj9llize_useiujf.jpg",
    description: "Complete exterior painting of lakefront multi-unit residential building"
  },
  {
    id: 15,
    title: "Garage Door Transformation",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/fcy9mumd_new1.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/fcy9mumd_new1.jpg",
    description: "Dramatic before/after garage door painting from green to sleek black"
  },
  {
    id: 16,
    title: "Outdoor Gazebo Refinishing",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/85bjk29g_new2.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/85bjk29g_new2.jpg",
    description: "Professional backyard gazebo painting with attention to detail"
  },
  {
    id: 17,
    title: "Custom Home Exterior",
    category: "Luxury Projects",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/s46rlijk_new3.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/s46rlijk_new3.jpg",
    description: "Tudor-style home with custom pergola and deck staining"
  },
  {
    id: 18,
    title: "Pool House Exterior",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/xl4wjha8_new4.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/xl4wjha8_new4.jpg",
    description: "Contemporary pool house exterior with rich wood stain finish"
  },
  {
    id: 19,
    title: "Two-Tone Exterior Painting",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/8v97vcwg_new5.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/8v97vcwg_new5.jpg",
    description: "Modern two-tone exterior with professional ladder safety practices"
  },
  {
    id: 20,
    title: "Modern Brick Home Exterior",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/dbg6q40h_new6.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/dbg6q40h_new6.jpg",
    description: "Stunning brick home with custom black garage door and trim"
  },
  {
    id: 21,
    title: "Garage Interior Transformation",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/kmq08owv_new7.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/kmq08owv_new7.jpg",
    description: "Complete garage interior painting from unfinished to pristine white finish"
  },
  {
    id: 22,
    title: "Interior Hallway Renovation",
    category: "Luxury Projects",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/o2ourg7m_new8.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/o2ourg7m_new8.jpg",
    description: "Dramatic hallway transformation with modern white walls and black trim accents"
  },
  {
    id: 23,
    title: "Custom Curved Staircase",
    category: "Luxury Projects",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/e7qvlkrb_new9.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/e7qvlkrb_new9.jpg",
    description: "Elegant curved staircase with custom wood stain and precision white risers"
  },
  {
    id: 24,
    title: "Luxury Pool Estate - Daytime",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/9g0ioupo_aaa.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/9g0ioupo_aaa.jpg",
    description: "Stunning backyard oasis with custom pool and professional landscaping"
  },
  {
    id: 25,
    title: "Luxury Pool Estate - Evening",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/ks9ltkfi_aaaa.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/ks9ltkfi_aaaa.jpg",
    description: "Elegant evening view of custom painted home with illuminated pool area"
  },
  {
    id: 26,
    title: "Luxury Brick Mansion with Pool",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/m6v35e5f_abc.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/m6v35e5f_abc.jpg",
    description: "Large brick estate home with custom exterior painting and pool features"
  },
  {
    id: 27,
    title: "Elegant Estate Home",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/bmrrdmhq_abcd.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/bmrrdmhq_abcd.jpg",
    description: "Beautiful estate exterior with custom paint and manicured landscaping"
  },
  {
    id: 28,
    title: "Premium Luxury Home Exterior",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/i61152fi_european_touch_painting__1530639414_1815457451745421306_2266216718.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/i61152fi_european_touch_painting__1530639414_1815457451745421306_2266216718.jpg",
    description: "Stunning luxury home with multi-textured exterior and custom garage door painting"
  },
  {
    id: 29,
    title: "Modern Condo Kitchen",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/pjldry6j_european_touch_painting__1559309713_2055961351811310503_2266216718.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/pjldry6j_european_touch_painting__1559309713_2055961351811310503_2266216718.jpg",
    description: "Contemporary condo kitchen with glass partition and custom cabinet painting"
  },
  {
    id: 30,
    title: "Luxury Condo Basement",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/ewrsw3t5_european_touch_painting__1572730738_2168545065610724589_2266216718.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/ewrsw3t5_european_touch_painting__1572730738_2168545065610724589_2266216718.jpg",
    description: "Modern basement with floating stairs, yellow accent column and premium finishes"
  },
  {
    id: 31,
    title: "Commercial Bathroom Renovation",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/istdfyo2_european_touch_painting__1666186299_2952507129937279458_2266216718.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/istdfyo2_european_touch_painting__1666186299_2952507129937279458_2266216718.jpg",
    description: "Stylish commercial bathroom with teal blue accent tile and modern fixtures"
  },
  {
    id: 32,
    title: "Office Building Hallway",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/kig5rpoi_european_touch_painting__1559309713_2055961351819762808_2266216718.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/kig5rpoi_european_touch_painting__1559309713_2055961351819762808_2266216718.jpg",
    description: "Commercial hallway with geometric checkered floor and professional painting"
  },
  {
    id: 33,
    title: "High-Rise Condo Under Construction",
    category: "Condos",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/9xtsiw4y_european_touch_painting__1555452946_2023608441248784359_2266216718.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/9xtsiw4y_european_touch_painting__1555452946_2023608441248784359_2266216718.jpg",
    description: "Toronto high-rise condo painting project with stunning city skyline views"
  },
  {
    id: 34,
    title: "Luxury Pool Area Service",
    category: "Residential",
    before: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/nli1j88c_new10.jpg",
    after: "https://customer-assets.emergentagent.com/job_european-touch-paint/artifacts/nli1j88c_new10.jpg",
    description: "Premium residential pool area maintenance and surrounding paver installation"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Downtown Condo Owner",
    text: "European Touch transformed our condo completely. The attention to detail was impeccable, and they left the place spotless every day. Highly recommend!",
    rating: 5
  },
  {
    id: 2,
    name: "James Richardson",
    location: "Commercial Property Manager",
    text: "We've used European Touch for multiple office buildings. Always professional, on time, and the quality is consistently excellent. They're our go-to painting contractor.",
    rating: 5
  },
  {
    id: 3,
    name: "Maria & David Torres",
    location: "Residential Homeowners",
    text: "From the initial consultation to the final walkthrough, everything was perfect. They helped us choose the perfect colors and the finish is absolutely beautiful.",
    rating: 5
  },
  {
    id: 4,
    name: "Robert Chen",
    location: "Luxury Home Owner",
    text: "The custom finishes they created in our home are stunning. True craftsmen who take pride in their work. Worth every penny.",
    rating: 5
  },
  {
    id: 5,
    name: "Jennifer Patel",
    location: "Oakville Homeowner",
    text: "Outstanding service from start to finish! The team was punctual, respectful, and delivered exceptional results. Our home looks brand new. Couldn't be happier!",
    rating: 5
  },
  {
    id: 6,
    name: "Michael Anderson",
    location: "Mississauga Resident",
    text: "European Touch exceeded all our expectations. From the initial quote to the final coat, everything was handled with professionalism and care. Highly skilled team!",
    rating: 5
  }
];

export const aboutContent = {
  story: "European Touch Painting was founded on the principle that every space deserves exceptional craftsmanship. With over 23 years of experience in residential and commercial painting, we bring European precision and attention to detail to every project.",
  mission: "To deliver premium painting services that transform spaces and exceed expectations, combining traditional craftsmanship with modern techniques.",
  values: [
    {
      title: "Quality First",
      description: "We never compromise on materials or workmanship. Every project receives the same meticulous attention to detail."
    },
    {
      title: "Professionalism",
      description: "Licensed, insured, and committed to maintaining clean, safe job sites with respectful, punctual service."
    },
    {
      title: "Client Satisfaction",
      description: "Your vision is our priority. We work closely with you from consultation to completion to ensure perfect results."
    }
  ],
  stats: [
    { number: "23+", label: "Years Experience" },
    { number: "700+", label: "Projects Completed" },
    { number: "100%", label: "Insured & Licensed" },
    { number: "4.98★", label: "Average Rating" }
  ]
};
